import { titleCase } from 'util/StringUtils'

export const formatNetWorthRange = (netWorth: string) =>
  !netWorth ? '' : `${netWorth.toUpperCase().replace(/-/, '–')}`.replace('$<', '<$')

export const formatEnumByLabel = (item: string | string[], options: { label: string; value: any }[]) => {
  for (let option of options) {
    if (item === option.value) {
      return option.label
    }
  }
  return item
}

export const formatEnumMulti = (value: string | string[]) => {
  let arrayValue: string[]
  if (Array.isArray(value)) arrayValue = value
  else arrayValue = value.split(',')
  return arrayValue.map(s => titleCase(s.replace(/_/g, ' '))).join(', ')
}

export const arraysEqual = (_arr1: any[], _arr2: any[]) => {
  if (!Array.isArray(_arr1) || !Array.isArray(_arr2) || _arr1.length !== _arr2.length) return false

  var arr1 = _arr1.concat().sort()
  var arr2 = _arr2.concat().sort()

  for (var i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) return false
  }

  return true
}
